module.exports = __webpack_public_path__ + "static/index/img/avatar.ec125b37.png";